export default function lazyImageLoader() {
  return {
      init() {
          this.observeImages();
          this.loadSources();
      },
      observeImages() {
          const images = this.$el.querySelectorAll("img[data-src]");

          const loadImage = (img) => {
              img.setAttribute("src", img.getAttribute("data-src"));
              img.onload = () => {
                  img.removeAttribute("data-src");
              };
          };

          const observer = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                  if (entry.isIntersecting) {
                      entry.target.setAttribute('loading', 'eager');
                      loadImage(entry.target);
                      observer.unobserve(entry.target);
                  } else {
                      entry.target.setAttribute('loading', 'lazy');
                  }
              });
          }, {
              rootMargin: '0px',
              threshold: 0.1
          });

          images.forEach(img => observer.observe(img));
      },
      loadSources() {
          const sources = this.$el.querySelectorAll("source[data-srcset]");
          sources.forEach((source) => {
              source.setAttribute("srcset", source.getAttribute("data-srcset"));
              source.onload = () => {
                  source.removeAttribute("data-srcset");
              };
          });
      }
  };
}